import {
  NJInlineMessage,
  NJLink,
} from "@engie-group/fluid-design-system-react";

export const ErrorFallback = ({ error }: { error?: string }) => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "var(--nj-semantic-color-background-neutral-primary-default)",
      }}
    >
      <NJInlineMessage>
        <span data-child-name="njInlineMessageTitle">
          <b>Erreur</b> Impossible d'accéder à l'application
        </span>
        <div>
          {error ? error : "Une erreur s'est produite lors de l'accès à l'application"}{" "}
          <NJLink href="" variant="high_contrast">
            recharger la page
          </NJLink>
        </div>
      </NJInlineMessage>
    </div>
  );
};
